import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../../components/shared/AuthContext';
import { useTeamContext } from '../../context/TeamContext';
import { useUserPlan } from '../../hooks/useUserPlan';
import PlanTierLabel from '../../components/billing/PlanTierLabel';
import { FEATURE } from '../../config/planFeatures';
import { usePlanGate } from '../../hooks/usePlanGate';

export default function TeamCreatePage() {
  const { apiClient } = useContext(AuthContext);
  const { refresh } = useTeamContext();
  const { canCreateTeam } = useUserPlan();
  const { blockUnlessFeature } = usePlanGate();
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [slug, setSlug] = useState('');
  const [description, setDescription] = useState('');
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (blockUnlessFeature(FEATURE.TEAM_CREATE)) {
      return;
    }
    setSaving(true);
    setError('');
    try {
      const res = await apiClient.post('/api/organizations', { name, slug, description });
      await refresh();
      navigate(`/teams/${res.data.id}`);
    } catch (err) {
      setError(err.response?.data?.message || err.response?.data?.detail || 'Could not create team.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="teams-card" style={{ maxWidth: 520 }}>
      <h2>
        Create organization
        {!canCreateTeam && <PlanTierLabel tier="Team" />}
      </h2>
      {error && <div className="teams-error" role="alert">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="teams-form-row">
          <label htmlFor="team-name">Team name</label>
          <input id="team-name" value={name} onChange={(e) => setName(e.target.value)} required />
        </div>
        <div className="teams-form-row">
          <label htmlFor="team-slug">URL slug (optional)</label>
          <input id="team-slug" value={slug} onChange={(e) => setSlug(e.target.value)} placeholder="acme-engineering" />
        </div>
        <div className="teams-form-row">
          <label htmlFor="team-desc">Description</label>
          <textarea id="team-desc" rows={3} value={description} onChange={(e) => setDescription(e.target.value)} />
        </div>
        <button type="submit" className="teams-btn" disabled={saving}>
          {saving ? 'Creating…' : 'Create team'}
        </button>
      </form>
    </div>
  );
}
